import * as React from 'react';

import { SkipToContent as SkipToContentElement } from 'src/explore/elements/SkipToContent';

const SkipToContent: React.FC = () => <SkipToContentElement />;

export default SkipToContent;
